
import Hero from "@/components/Hero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, Check } from "lucide-react";

const SomaticCoaching = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Somaatiline enesejuhtimise coaching"
        subtitle="Avasta terviklik lähenemine, mis ühendab keha ja meele ning toetab sinu isiklikku kasvu."
        bgColor="bg-gradient-to-r from-kaija-sage to-kaija-light"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <div className="w-20 h-1 bg-kaija-slate rounded-full mx-auto mb-8"></div>
            <p className="text-gray-700 mb-10 text-lg leading-relaxed">
              Olen Kaija Alliksaar, somaatiline enesejuhtimise coach, kellel on üle 15 aasta juhtimiskogemust. Toetan naisi, aidates neil leida tasakaal ja ületada raskusi, kasutades kehateadlikku ja traumateadlikku lähenemist.
            </p>
            
            <h2 className="text-3xl font-medium mb-4">Heaolu, tasakaal ja isiklik areng</h2>
            <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-6"></div>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Toetan sind teekonnal vabanemaks piiravatest mõttemustritest, tuues teadlikkust trauma mõjust ja ennast juhtides luua võimaluse kujundada selline elu, mida igatsed. Pakun turvalist ja hinnangutevaba keskkonda, kus saad ennast sügavamalt tundma õppida just endale sobivas tempos. Läbi somaatilise kogemise oma keha ja meele koostööd parendada ning isiklikult kasvada.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Left side image */}
            <div className="md:col-span-1">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-tr from-kaija-sage to-kaija-light opacity-30 blur-lg rounded-lg"></div>
                <img 
                  src="/images/IMG_3037_resized-768x1024.jpg" 
                  alt="Somaatiline enesejuhtimise coaching" 
                  className="rounded-lg shadow-md w-full sticky top-24 relative z-10"
                />
              </div>
            </div>
            
            {/* Right side content */}
            <div className="md:col-span-2 space-y-8">
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light/70 p-8 rounded-lg shadow-sm">
                <h2 className="text-2xl font-medium mb-6">Heaolu, tasakaal ja isiklik areng</h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Toetan sind teekonnal vabanemaks piiravatest mõttemustritest, tuues teadlikkust trauma mõjust ja ennast juhtides luua võimaluse kujundada selline elu, mida igatsed. Pakun turvalist ja hinnangutevaba keskkonda, kus saad ennast sügavamalt tundma õppida just endale sobivas tempos. Läbi somaatilise kogemise oma keha ja meele koostööd parendada ning isiklikult kasvada.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-medium mb-6">Coachingpaketid</h2>
                <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
                <div className="space-y-6">
                  <Card className="overflow-hidden transition-all duration-300 hover:shadow-lg border-kaija-slate/20">
                    <div className="absolute h-full w-1 bg-gradient-to-b from-kaija-slate to-kaija-slate/40 left-0 top-0"></div>
                    <CardHeader className="bg-gradient-to-r from-kaija-sage/30 to-transparent">
                      <CardTitle className="text-kaija-slate">Samm Edasi – 3-kuuline pakett</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardDescription className="text-gray-700 text-base leading-relaxed">
                        Sobib neile, kes soovivad teha esimesi samme isikliku kasvu ja enesejuhtimise teel. Programm keskendub sisemiste barjääride ületamisele ja eneseteadlikkuse kasvatamisele. Koos uuritakse, mis takistab edasi liikumast, ja töötatakse välja strateegiad, mis aitavad saavutada tasakaalu ja kindlustunnet igapäevaelus.
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white group transition-all duration-300">
                        <Link to="/contact" className="flex items-center">
                          Võta ühendust <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </CardFooter>
                  </Card>
                  
                  <Card className="overflow-hidden transition-all duration-300 hover:shadow-lg border-kaija-slate/20">
                    <div className="absolute h-full w-1 bg-gradient-to-b from-kaija-slate to-kaija-slate/40 left-0 top-0"></div>
                    <CardHeader className="bg-gradient-to-r from-kaija-sage/30 to-transparent">
                      <CardTitle className="text-kaija-slate">Kasv ja Kestvus – 6-kuuline pakett</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardDescription className="text-gray-700 text-base leading-relaxed">
                        Mõeldud neile, kes soovivad süvitsi minna ja luua püsivaid muutusi oma elus. Programm pakub põhjalikku tööd somaatilise ja traumateadliku enesejuhtimise kaudu, et ületada väljakutseid ja liikuda kindlalt oma eesmärkide poole. Õpitakse tundma keha ja meele vahelisi seoseid, tugevdama sisemist jõudu ja arendama uusi toimetulekustrateegiaid.
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white group transition-all duration-300">
                        <Link to="/contact" className="flex items-center">
                          Võta ühendust <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </CardFooter>
                  </Card>
                  
                  <Card className="overflow-hidden transition-all duration-300 hover:shadow-lg border-kaija-slate/20">
                    <div className="absolute h-full w-1 bg-gradient-to-b from-kaija-slate to-kaija-slate/40 left-0 top-0"></div>
                    <CardHeader className="bg-gradient-to-r from-kaija-sage/30 to-transparent">
                      <CardTitle className="text-kaija-slate">Elujõud ja Tasakaal – 12-kuuline pakett</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardDescription className="text-gray-700 text-base leading-relaxed">
                        Mõeldud neile, kes soovivad põhjalikku ja pikaajalist tuge, et muuta oma elu ja saavutada sügav sisemine rahu. Programm ühendab kõik tööriistad ja meetodid, pakkudes terviklikku lähenemist, mis hõlmab nii keha kui ka meelt. Töö käigus avastatakse ja vabastatakse sügavalt juurdunud mustrid, arendatakse enesejuhtimise oskusi ja liigutakse enesekindlalt oma unistuste suunas.
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white group transition-all duration-300">
                        <Link to="/contact" className="flex items-center">
                          Võta ühendust <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </CardFooter>
                  </Card>
                </div>
              </div>
              
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light/70 p-8 rounded-lg shadow-sm">
                <h2 className="text-xl font-medium mb-6">Mida oodata?</h2>
                <div className="w-12 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
                <ul className="space-y-6">
                  <li className="flex items-start">
                    <div className="bg-kaija-slate rounded-full w-8 h-8 flex items-center justify-center text-white mr-4 mt-0.5 flex-shrink-0 shadow-md">1</div>
                    <div>
                      <h3 className="font-medium text-lg">Tasuta tutvumiskõne</h3>
                      <p className="text-gray-700 mt-2 leading-relaxed">20-minutiline kõne, et arutada vajadusi ja eesmärke ning veenduda koostöö sobivuses.</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-kaija-slate rounded-full w-8 h-8 flex items-center justify-center text-white mr-4 mt-0.5 flex-shrink-0 shadow-md">2</div>
                    <div>
                      <h3 className="font-medium text-lg">Kohtumised Zoomis</h3>
                      <p className="text-gray-700 mt-2 leading-relaxed">Kõik sessioonid toimuvad Zoomi vahendusel, mugavalt kodust või kontorist.</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-kaija-slate rounded-full w-8 h-8 flex items-center justify-center text-white mr-4 mt-0.5 flex-shrink-0 shadow-md">3</div>
                    <div>
                      <h3 className="font-medium text-lg">Sessioonide sagedus ja kestus</h3>
                      <p className="text-gray-700 mt-2 leading-relaxed">Iga kahe nädala tagant, 75-minutilised sessioonid, pakkudes järjepidevat tuge ja juhendamist.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-kaija-light to-kaija-sage/70 text-center">
        <div className="container-custom">
          <h2 className="text-2xl md:text-3xl font-medium mb-6">Alusta enda teekonda</h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto text-lg">
            Võta täna ühendust ja sisene transformatsiooni ja isikliku arengu maailma.
          </p>
          <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
            <Link to="/contact" className="flex items-center">
              Võta ühendust <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default SomaticCoaching;
